<template lang="pug">
.doPOLLINGCENTER
  .roomTitle(v-once) {{$attrs.cont.departmentName}}
    div.tl().point
    div.tr().point
    div.bl().point
    div.br().point
  .left(v-show='sta===0')
    .left1
      .title  {{onQuestionList.model==="QUESTIONNAIRESURVEY"?'问卷题项选择':'访谈题项选择'}}
      .tisp {{onQuestionList.model==="QUESTIONNAIRESURVEY"?'点击题选即可选择题目组成问卷。':'点击资料了解详情'}}
      li.li-cont(v-for='(v,index) in onQuestionList.questionList',@click='Selection(index)') {{v.title}}
    .left2
      .title  已选择题项
      .tisp {{onQuestionList.model==="QUESTIONNAIRESURVEY"?'点击题选即可取消选择。':'点击资料即可取消选择'}}
      li.li-cont(v-for='(v,index) in questionList',@click='delSelection(index)') {{v.title}}
      button.Determine(@click='Determine')  确定
  .left-Tow(v-show='sta===1')
      li(v-for='(v,index) in questionList')
        p.title(:class="quesListActive ? 'active' : ''") {{v.title}}
        p(v-html='v.content')
  .rigth(v-if='sta===1')
    .title  {{onQuestionList.title}}
    Input(v-model='content',type="textarea",:maxlength="500",:autosize="{minRows: 8,maxRows: 8}",:show-word-limit='true').textarea
    Button.Determine(@click='Determine1',:loading="isWorking")  确定
</template>

<script>
export default {
  data() {
    return {
      Completed: sessionStorage.getItem("Completed") === "true",
      questionList: [],
      step: ["FORMULATE", "EXECUTE", "ASSESS", "FINALITY"],
      onQuestionList: {},
      sta: 0,
      cont: this.$attrs.cont,
      content: "",
      id: "",
      quesListActive: false,
      isWorking: false
    };
  },
  created() {},
  mounted() {
    this.onQuestionList = this.subject;
    console.log(this.$parent.SceneList[this.$parent.SceneIndex]);
    console.log(this.onQuestionList);
    this.query();
  },
  methods: {
    query() {
      const data = {
        caseHallId: this.$store.state.doCase.caseData[
          this.step[+sessionStorage.getItem("doIndex")]
        ].tsId,
        classId: sessionStorage.getItem("classId"),
        experimentId: this.$store.state.doCase.experimentId,
        pyId: this.$store.state.doCase.caseId,
        tsId: this.$parent.SceneList[this.$parent.SceneIndex].id,
        userId: this.$role.code
      };
      this.$http.listStuControl(data).then(res => {
        console.log(res);
        if (res.data.data) {
          this.content = res.data.data[0].questionAnswer;
          this.id = res.data.data[0].id;
        }
      });
    },
    Determine1() {
      // 保存数据
      if (this.Completed) {
        return this.$emit("SignOut");
      }
      if (!this.content) {
        return this.$Message.error("请填写完成!");
      }
      const data = [
        {
          caseHallId: this.$store.state.doCase.caseData[
            this.step[+sessionStorage.getItem("doIndex")]
          ].tsId,
          caseStep: this.step[+sessionStorage.getItem("doIndex")],
          classId: sessionStorage.getItem("classId"),
          controlId: this.$parent.SceneList[this.$parent.SceneIndex].id,
          id: this.id ? this.id : "",
          controlTypes: this.onQuestionList.model,
          experimentId: this.$store.state.doCase.experimentId,
          pyId: this.$store.state.doCase.caseId,
          questionAnswer: this.content,
          tsId: this.$parent.SceneList[this.$parent.SceneIndex].id,
          userId: this.$role.code
        }
      ];
      console.log(data);
      if (this.isWorking === false) {
        this.isWorking = true;
        this.$http.createStuControl(data).then(() => {
          this.$emit("SignOut");
        }).catch(() => {
          this.isWorking = false;
        });
      }
    },
    Determine() {
      // 确定按钮
      if (this.questionList.length === 0) {
        return this.$Message.error("请至少选择一项调查");
      }
      console.log(this);
      // console.log(this.onQuestionList.trueAnswer.length);
      if (this.questionList.length > this.onQuestionList.trueAnswer.length) {
        this.$Message.info({
          render: h => {
            return h("span", [
              "最多选择",
              h("span", this.onQuestionList.trueAnswer.length),
              "项"
            ]);
          }
        });
      } else {
        this.quesListActive = true;
        this.sta += 1;
      }
      // this.sta += 1;
    },
    delSelection(index) {
      this.onQuestionList.questionList.push(this.questionList[index]);
      this.questionList.splice(index, 1);
    },
    Selection(index) {
      this.questionList.push(this.onQuestionList.questionList[index]);
      this.onQuestionList.questionList.splice(index, 1);
    }
  },
  computed: {
    subject() {
      return JSON.parse(
        this.$parent.SceneList[this.$parent.SceneIndex].functionName
      );
    }
  }
};
</script>
<style lang="stylus" scoped>
.doPOLLINGCENTER
  position absolute
  background url('../../../assets/case/department/po.png')
  background-size 100vw
  height 100vh
  width 100vw
  z-index 5
  .roomTitle
    position absolute
    top 76px
    left 0
    right 0
    margin 0 auto
    width 150px
    height 40px
    background-color rgba(245, 166, 35, 1)
    border-radius 4px
    opacity 0.8022
    font-size 18px
    font-family fzhpfw
    font-weight normal
    color rgba(255, 255, 255, 1)
    line-height 40px
    .point
      width 4px
      height 4px
      background rgba(255, 255, 255, 1)
      border-radius 2px
      opacity 0.3043
      &:nth-child(1)
        position absolute
        top 4px
        left 6px
      &:nth-child(2)
        position absolute
        top 4px
        right 6px
      &:nth-child(3)
        position absolute
        bottom 4px
        left 6px
      &:nth-child(4)
        position absolute
        bottom 4px
        right 6px
  .left-Tow
    width 50%
    background #ffffff
    height 100%
    position absolute
    text-align left
    overflow auto
    transition 1s
    padding 80px 32px
    li
      .title
        cursor pointer
        width 396px
        min-height 48px
        background rgba(242, 245, 250, 1)
        border-radius 4px
        border 1px solid rgba(210, 221, 236, 1)
        font-size 14px
        font-family MicrosoftYaHeiUI
        color rgba(42, 46, 54, 0.75)
        line-height 48px
        padding-left 8px
        margin-top 20px
        &.active
          background transparent
          border none
          width auto
  .rigth
    padding 29px 32px
    text-align left
    width 35%
    height 348px
    background rgba(255, 255, 255, 1)
    box-shadow 0px 2px 4px 0px rgba(0, 0, 0, 0.2)
    border-radius 4px
    position absolute
    bottom 0
    margin auto
    top 0
    right 7%
    .title
      font-size 16px
      font-family MicrosoftYaHeiUI
      color rgba(42, 46, 54, 1)
      line-height 21px
    .textarea
      width 100%
      height 70%
      border-radius 4px
      outline none
      padding 5px
      resize none
      margin-top 10px
  .left
    width 70%
    background #ffffff
    transition 1s
    height 100%
    position relative
    text-align left
    .title
      font-size 20px
      font-family MicrosoftYaHeiUI-Bold
      font-weight bold
      color rgba(42, 46, 54, 1)
      line-height 25px
    .tisp
      font-size 14px
      font-family MicrosoftYaHeiUI
      color rgba(128, 128, 128, 1)
      line-height 18px
      margin-top 32px
    .li-cont
      cursor pointer
      width 396px
      min-height 48px
      background rgba(242, 245, 250, 1)
      border-radius 4px
      border 1px solid rgba(210, 221, 236, 1)
      font-size 14px
      font-family MicrosoftYaHeiUI
      color rgba(42, 46, 54, 0.75)
      line-height 48px
      padding-left 8px
      margin-top 20px
    .left1
      padding 36px 32px
      width 50%
      height 100%
      border-right 1px solid #dddddd
      position absolute
      overflow auto
      left 0
    .left2
      padding 36px 32px
      position absolute
      right 0
      overflow auto
      height 100%
      width 50%
  .Determine
    width 100px
    height 40px
    background #3a76d2
    border-radius 4px
    border none
    outline none
    font-size 14px
    font-family MicrosoftYaHeiUI
    color #fff
    line-height 18px
    float right
</style>
